import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Spinner from 'react-bootstrap/Spinner';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import roleType from '../../constants/roles';

import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { withFirebase } from '../Firebase';
import { withAuthorization } from '../Session';

class Royalty extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            alert: 0,
            alertMessage: '',
            flag: false,
            columns: [
                { title: 'Store Group', field: 'storeGroup' },
                { title: 'Royalty(%)', field: 'royalty', type: 'numeric' },
                {
                    title: 'Last Updated (mm/dd/yyyy)',
                    field: 'lastUpdated',
                    editable: 'never'
                }
            ],
            data: []
        };
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        await RestServices.getRoyalty(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    if (this._isMounted) {
                        this.setState({ alert: 1, alertMessage: data.error });
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({ data: data, flag: true, alert: 0 });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    async deleteRow(oldData) {
        await RestServices.deleteRoyalty(
            localStorage.getItem('FirebaseToken'),
            oldData.storeGroup
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.success) {
                    this.setState((prevState) => {
                        const data = [...prevState.data];
                        data.splice(data.indexOf(oldData), 1);
                        return { ...prevState, data };
                    });
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    async addUpdateRow(oldData, newData) {
        await RestServices.updateRoyalty(
            localStorage.getItem('FirebaseToken'),
            oldData.storeGroup,
            newData
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState((prevState) => {
                    const data = [...prevState.data];
                    data[data.indexOf(oldData)] = newData;
                    return { ...prevState, data };
                });
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    async addRow(newData) {
        await RestServices.updateRoyalty(
            localStorage.getItem('FirebaseToken'),
            newData.storeGroup,
            newData
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState((prevState) => {
                    const data = [...prevState.data];
                    data.push(newData);
                    return { ...prevState, data };
                });
            })
            .catch((err) => {
                
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    async updateDeleteRow(oldData, newData) {
        await RestServices.updateDeleteRoyalty(
            localStorage.getItem('FirebaseToken'),
            oldData.storeGroup,
            newData
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState((prevState) => {
                    const data = [...prevState.data];
                    data[data.indexOf(oldData)] = newData;
                    return { ...prevState, data };
                });

                
            })
            .catch((err) => {
                //console.log(err);
            });
    }

    render() {
        function retrieveDate() {
            var today = new Date();
            var dd = today.getDate();

            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }
            today = mm + '/' + dd + '/' + yyyy;
            return today;
        }

        return (
            <Container>
                <Row>
                    <KeyboardBackspaceRoundedIcon
                        style={{ cursor: 'pointer', color: 'blue' }}
                        onClick={this.props.flagHandler}
                    />
                    <h4 style={{ marginLeft: '1rem' }}>Royality</h4>
                </Row>
                <div>
                    <hr />
                </div>

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.flag === false && <Spinner animation="border" />}
                {this.state.flag === true && (
                    <MaterialTable
                        components={{
                            Pagination: PatchedPagination
                        }}
                        title="Royality Data"
                        columns={this.state.columns}
                        data={this.state.data}
                        options={{
                            filtering: true,
                            pageSize: 15,
                            pageSizeOptions: [15, 25, 50, 100]
                        }}
                        editable={
                            this.props.role == 'Admin'
                                ? {
                                      onRowAdd: (newData) =>
                                          new Promise((resolve) => {
                                              setTimeout(() => {
                                                  resolve();
                                                  if (
                                                      typeof newData.storeGroup !==
                                                          'undefined' &&
                                                      typeof newData.royalty !==
                                                          'undefined' &&
                                                      newData.storeGroup !==
                                                          '' &&
                                                      newData.royalty !== ''
                                                  ) {
                                                      newData = {
                                                          ...newData,
                                                          lastUpdated:
                                                              retrieveDate()
                                                      };
                                                      this.addRow(newData);
                                                  }
                                              }, 600);
                                          }),
                                      onRowUpdate: (newData, oldData) =>
                                          new Promise((resolve) => {
                                              setTimeout(() => {
                                                  resolve();
                                                  if (oldData) {
                                                      if (
                                                          newData.storeGroup !==
                                                              '' &&
                                                          newData.royalty !== ''
                                                      ) {
                                                          newData = {
                                                              ...newData,
                                                              lastUpdated:
                                                                  retrieveDate()
                                                          };

                                                          if (
                                                              oldData.storeGroup ===
                                                              newData.storeGroup
                                                          ) {
                                                              this.addUpdateRow(
                                                                  oldData,
                                                                  newData
                                                              );
                                                          } else {
                                                              this.updateDeleteRow(
                                                                  oldData,
                                                                  newData
                                                              );
                                                          }
                                                      }
                                                  }
                                              }, 600);
                                          }),
                                      onRowDelete: (oldData) =>
                                          this.deleteRow(oldData)
                                  }
                                : {}
                        }
                    />
                )}
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(Royalty);
